import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取当前登录用户所属供应商以及下属供应商
 * @param data
 *
 */
export const getMerchantList = () => {
  return request({
    url: env.ferryUrl + '/merchant/getMerchantList',
    method: 'GET'
  })
}
/**
 * 获取司机信息分页
 * @param data
 *
 */
export const getDriverPage = (data) => {
  return request({
    url: env.ferryUrl + '/driver/page',
    method: 'POST',
    data
  })
}

/**
 * 获取地区树
 * @param data
 *
 */
export const getDriverAreaTree = (data) => {
  return request({
    url: env.ferryUrl + '/driver/area-tree',
    method: 'GET',
    data
  })
}
/**
 * 新增/编辑司机
 * @param data
 *
 */
export const saveOrUpdate = (data) => {
  return request({
    url: env.ferryUrl + '/driver/v2/saveOrUpdate',
    method: 'POST',
    data
  })
}
/**
 * 司机监管报备
 * @param data
 *
 */
export const driverReport = (data) => {
  return request({
    url: env.ferryUrl + '/driver/report',
    method: 'POST',
    data
  })
}
/**
 * 获取该供应商下未绑定司机的车辆
 * @param driverId
 *
 */
export const notBindCarInfo = (merchantId) => {
  return request({
    url: env.ferryUrl + `/driver/notBind/carInfo/${merchantId}`,
    method: 'GET'
  })
}

/**
 * 获取该司机已经绑定的车辆跟线路信息
 * @param driverId
 *
 */
export const bindCarInfo = (merchantId) => {
  return request({
    url: env.ferryUrl + `/driver/bindCarInfo/${merchantId}`,
    method: 'GET'
  })
}
/**
 * 获取供应商线路
 * @param driverId
 *
 */
export const queryAllLowLine = (id) => {
  return request({
    url: env.ferryUrl + `/lineAdmin/getLineByMerchantIds?merchantId=${id}`,
    method: 'GET'
  })
}
/**
 * 绑定车辆
 * @param driverId
 *
 */
export const driverBindCar = (data) => {
  return request({
    url: env.ferryUrl + '/driver/bindCar',
    method: 'POST',
    data
  })
}
/**
 * 封禁或解禁司机
 * @param data
 *
 */
export const driverBannedUnblock = (data) => {
  return request({
    url: env.ferryUrl + '/driver/banned/unblock',
    method: 'POST',
    data
  })
}
/**
 * 删除司机
 * @param data
 *
 */
export const driverDelete = (id) => {
  return request({
    url: env.ferryUrl + `/driver/delete/${id}`,
    method: 'GET'
  })
}
/**
 * 获取司机详情
 * @param data
 *
 */
export const getDriverInfo = (driverId) => {
  return request({
    url: env.ferryUrl + `/driver/driverInfo/${driverId}`,
    method: 'GET'
  })
}

/**
 * 车辆或司机审核接口
 * @param data
 *
 */
export const driverAudit = (data) => {
  return request({
    url: env.ferryUrl + '/driver/audit',
    method: 'POST',
    data
  })
}

// 获取绑定站点
export const getStation = (params) => {
  return request({
    url: env.ferryUrl + '/driver/stations',
    method: 'GET',
    params
  })
}
// 绑定站点
export const bindStation = (data) => {
  return request({
    // url: env.ferryUrl + '/driver/bind-station',
    url: env.ferryUrl + '/driver/bind-station/v2',
    method: 'POST',
    data
  })
}
